import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment"
import _ from "lodash";
import { Toast } from 'primereact/toast';
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import { Sidebar } from "primereact/sidebar";

import { Table } from "../../helpers"
import { Button, CheckboxField } from "../../helpers";

import Loading from "../../common/Loading";
import CopyToClipboard from "../../common/CopyToClipboard";
import PMCompanyName from "../../common/PMCompanyName";
import PMUserName from "../../common/PMUserName";
import ButtonGroup from "../../common/ButtonGroup";

import PIWiseInvoiceSearch from './Components/PIWiseInvoiceSearch'
import SellerPOAndPISplitView from "./Components/SellerPOAndPISplitView";
import PaymentHistory from "../VendorPaymentSummary/components/PaymentHistory";
import RaiseTicketModal from "./Components/RaiseTicketModal";
import PIWiseInvoiceBookingAlertsDialog from "./Components/PIWiseInvoiceBookingAlertsDialog";
import PIInvoiceBookingDashboard from "./Components/PIInvoiceBookingDashboard";

import { getPIInvoiceBookingAlerts, updatePurchaseInVoiceBookingStatus } from '../../services/api/invoiceBooking';
import { fetchInvoiceBookingList, setIsSearchVisible } from "../../services/redux/reducers/invoiceBooking/invoiceBooking";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchCompanyCreditPeriods, fetchHSNMasterData, fetchStates, fetchStatus } from "../../services/redux/reducers/commonThunk";
import { getExpenseCategories } from "../../services/api/expenseCategories";
import { getProcessLines } from "../../services/api/processLines";

import RaiseImg from "../../images/click.jpg"
import greyClockImg from "../../images/greyClock.png"
import checkInCircleImg from "../../images/check-circle.png"
import VPRupeeImg from "../../images/vp_rupee.jpg"
import WorkInProgressImg from "../../images/work-in-progress.png";

import "./index.css"

import { addDaysToDate, getDateString, getDateTimeString, getFullName, isMobile, numberConversion } from "../../utils";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "../../constants";


const PIWiseInvoiceBooking = () => {
    const [isLoading, setIsLoading] = useState(false)
    let   [selectedInvoice, setSelectedInvoice] = useState([])
    const [displayedVendorPayments, setDisplayedVendorPayments] = useState([])
    const [expenseCategories, setExpenseCategories] = useState([])

    const [visiblePIAndSellerPOSplitView, setVisiblePIAndSellerPOSplitView] = useState(false)
    const [selectedSellerPIPunch, setSelectedSellerPIPunch] = useState([])
    const [isVendorPaymentHistoryVisible, setIsVendorPaymentHistoryVisible] = useState(false)
    const [isRaiseTicketVisible, setIsRaiseTicketVisible] = useState(false)
    const [selectedRow, setSelectedRow] = useState({})
    const [visibleDuplicatePIPunchesView, setVisibleDuplicatePIPunchesView] = useState(false)
    const [duplicatePIPunches, setDuplicatePIPunches] = useState([])
    const [sellerPOItemsWithVendorPaymentButGRNNotDone, setSellerPOItemsWithVendorPaymentButGRNNotDone] = useState([])
    const [presentBookingStatus, setPresentBookingStatus] = useState('')
    const [isVisibleConfirmDialog, setIsVisibleConfirmDialog] = useState(false)
    const [sellerPIProcessLine, setSellerPIProcessLine] = useState({})

    let sellerPIPunch = useSelector(state => state.invoiceBookingPIWise.listInvoiceData?.data)
    const vendorPayments = useSelector(state => state.invoiceBookingPIWise.vendorPayments)
    const usersData = useSelector(state => state.userDetails)
    const isTableLoading = useSelector(state => state.invoiceBookingPIWise.loading)
    const paginationParams = useSelector(state => state.invoiceBookingPIWise.paginationParams)
    const searchParams = useSelector(state => state.invoiceBookingPIWise.searchParams)
    const isSearchVisible = useSelector(state => state.invoiceBookingPIWise.isSearchVisible)
    const isSearchActive = useSelector(state => state.invoiceBookingPIWise.isSearchActive)

    const statusList = useSelector((state) => state.common.status)

    const usersList = usersData.PMCompanyDetails.companyUsers

    const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)
    let { numberLocale, isSellerEInvoiceApplicable, autoSkipPIVerification } = pmCompanyConfig

    const dispatch = useDispatch()

    const isMobileDevice = isMobile()

    useEffect(()=>{
        dispatch(fetchHSNMasterData())
        dispatch(fetchStates())
        dispatch(fetchStatus())
        dispatch(fetchCompanyCreditPeriods())
        fetchExpenseCategories()
        getProcessLinesData()
    }, [])

    const fetchExpenseCategories = async () => {
		const response = await getExpenseCategories()
		if (response.failure){
			dispatch(raiseToast({severity:'error', summary: 'Expense Categories', detail: response.data.error}))
		}

		let sortedExpenseCategories = _.sortBy(response.data, "expenseCategoryName")
		setExpenseCategories(sortedExpenseCategories)
	}

    const getProcessLinesData = async () => {
        const processLineRes = await getProcessLines()
		if (processLineRes.failure){
			dispatch(raiseToast({severity:'error', summary: 'Process Lines', detail: processLineRes.data.error}))
		}

        const relatedSellerPIProcessLine = processLineRes.data.find(eachProcessLine => eachProcessLine.processLineId === 1)
		setSellerPIProcessLine(relatedSellerPIProcessLine)
    }

    const handleCopyClick = (docNo) => {
        if(docNo){
            navigator.clipboard.writeText(docNo)
            .then(() => {
                return dispatch(raiseToast({severity:'success', detail: "Copied!", life: 3000}))
            })
            .catch((error) => {
                return dispatch(raiseToast({severity:'error', detail: "Can't copy", life: 3000}))
            })
        }
    }

    const getBookingStatusBody = (row) => {
        const bookedUserId = row.bookedBy ? row.bookedBy : row.unbookedBy

        let bookedByUser = null 
        let bookedByUserName = ""
        if(bookedUserId){
            bookedByUser = usersList.find(user => user.userId == bookedUserId)
            if(bookedByUser){
                bookedByUserName += bookedByUser.firstName 
                if(bookedByUser.lastName){
                    bookedByUserName += " " + bookedByUser.lastName
                }
            }
        }

        let bookedOrUnbookedAt = row.bookedBy ? getDateString(row.bookedAt, DATE_TIME_FORMAT) : getDateString(row.unbookedAt, DATE_TIME_FORMAT)

        return(
            <div className={`text-center booked-tooltip-${row.sellerPIPunchId}`}>
                <div className={`${row['bookedStatus'] ? 'text-green-500' : 'text-red-600'}`} style={{fontSize: "12px", textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none' }}>{ (row['bookedStatus'] ? '' : 'NOT BOOKED') }</div>
                <div style={{fontSize: "12px", textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none'}} className="text-xs font-bold text-green-500">{row.unbookedBy ? "Unbooked by" : ""} {bookedByUserName}</div>
                <div style={{fontSize: "12px", textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none'}} className="text-xs text-green-500">{row?.bookedAt ? moment(row['bookedAt']).format(DATE_FORMAT) : null}</div>
                {bookedByUserName && <Tooltip target={`.booked-tooltip-${row.sellerPIPunchId}`} position="top">
                    <div className="flex flex-column m-0">
                        <p className="m-0"><span className="font-semibold"> {row.bookedBy ? "Booked By:" : "Unbooked By:" }</span>{` ${bookedByUserName}`}</p>
                        <p className="m-0"><span className="font-semibold">{row.bookedBy ? "Booked At:" : "Unbooked At:" }</span>{` ${bookedOrUnbookedAt}`}</p>
                    </div>
                </Tooltip>}
            </div>
        )
    }

    const getVerificationStatus = (row) => {
        let isVerified = row.verifiedBy ? true : false

        let verifiedByFullName = ``
        if(isVerified){
            const userDetails = usersList.find(eachPmUser => eachPmUser.userId === row.verifiedBy)
            verifiedByFullName = getFullName(userDetails.firstName, userDetails.lastName)
        }

        return(
            <div>
                {
                    isVerified ? 
                    <div className={`flex flex-column align-items-center justify-content-center verification-tooltip-${row.sellerPIPunchId}`}>
                        <span className="text-xs font-bold text-green-500">{verifiedByFullName}</span>
                        <span className="text-xs text-green-500">{getDateTimeString(row.verifiedAt, DATE_FORMAT)}</span>
                        <Tooltip target={`.verification-tooltip-${row.sellerPIPunchId}`} position="top">
                            <div className="flex flex-column m-0">
                                <p className="m-0"><span className="font-semibold">Verified By:</span>{` ${verifiedByFullName}`}</p>
                                <p className="m-0"><span className="font-semibold">Verified At:</span>{` ${getDateString(row.verifiedAt, DATE_TIME_FORMAT)}`}</p>
                            </div>
                        </Tooltip>
                    </div> :
                    <span className="text-red-600 text-xs">NOT VERIFIED</span>
                }
            </div>
        )
    }

    const getHeaderCheckbox = ()=>{
        return(
            <div className=""> <CheckboxField onChange={(e) => handleSelectClick(e)}  checked={sellerPIPunch?.length > 0 && sellerPIPunch?.length === selectedSellerPIPunch?.length}/></div>
        )
    }

    const getBodyCheckbox = (row)=>{
        const relatedSellerPIPunch = selectedSellerPIPunch?.find(eachSellerPIPunch => eachSellerPIPunch?.sellerPIPunchId === row?.sellerPIPunchId)
        return(
            <CheckboxField onChange={() => handleCheckboxClick(row)} checked={relatedSellerPIPunch ? true : false}/>
        )
    }

    const getPurchaseInvoiceBody = (row)=>{
        return(
            <div className="">
                <div style={{textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none'}}> <span style={{fontSize: "12px"}}></span> {row?.PIDocNo}</div>
                <div className="flex justify-content-center align-items-center" style={{fontWeight: "bold", fontSize: "13px"}}>
                    <span style={{fontSize: "12px", wordBreak: "keep-all", textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none'}}>{row?.sellerPINumber ? " " + row?.sellerPINumber : "-" }</span><i className="pi pi-eye cursor-pointer ml-1 compare-tooltip" onClick={() => {setVisiblePIAndSellerPOSplitView(true); setSelectedInvoice(row)}} />
                </div>
                <Tooltip target={`.compare-tooltip`} showDelay={1000} hideDelay={300} position="top">
                    <p>Click here to view both seller PO and seller PI</p>
                </Tooltip>
            </div> 
        )
    }

    const getEInvoiceBody = (row)=>{
        if (!row.EInvoiceNumber){
            return "-"
        }
        return(
            <div className="">
                <div style={{textDecoration: row.sellerPOStatus === 6 ? 'line-through' : 'none'}}> <span style={{fontSize: "12px"}}></span> {row.EInvoiceNumber}</div>
                <div>
                    <a href={row.EInvoiceDocProof} target="_blank" style={{cursor: "pointer", color: 'black', fontWeight: 'bold', textDecoration: row.sellerPOStatus === 6 ? 'line-through' : 'none'}}>View</a>
                </div>
            </div> 
        )
    }

    const getCompanyBody = (row)=>{
        // return(
        //     <div className="">
        //         <div style={{ textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none' }}>{row["companyName"]}</div> 
        //         {/* <div>{getCompanyShortName(row["companyName"])}</div>*/}
        //     </div> 
        // )
        let companyName = row["companyName"]

        return <PMCompanyName companyName={companyName} companyId={row.companyId}/>
    }

    const getKAMBody = (row)=>{
        // return(
        //     <div className="">
        //         <div style={{textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none'}}>{row["firstName"]+" "+row["lastName"]}</div>
        //     </div> 
        // )
        let kamName = row["firstName"] 

        if(row["lastName"]){
            kamName = kamName + " " + row["lastName"]
        }
        return <PMUserName userName={kamName} userId={row.createdBy}/>
    }

    const getSellerPIDateBody = (row)=>{
        let dateString = getDateString(row?.sellerPIDate)
        let uploadedDateString = getDateString(row?.sellerPIUploadedDate)
        return(
            <div className="">
                <div style={{textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none'}}>{row?.sellerPIDate ? dateString : "-"}</div>
                <div style={{textDecoration: row.sellerPOStatus ===6 ? 'line-through' : 'none'}}>Upload: {row.sellerPIUploadedDate ? uploadedDateString : "-"}</div>
            </div> 
        )
    }

    const getTotalAmountBody = (row)=>{
        return(
            <div className="text-center">
                <div style={{textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none'}}>{numberConversion(row?.sellerPITotalAmount, numberLocale)}</div>
            </div> 
        )
    }

    const getSellerPIUploadedDateBody = (row)=>{
        let dateString = getDateString(row?.sellerPIUploadedDate)
        return(
            <div className="text-center">
                <div style={{textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none'}}>{row?.sellerPIUploadedDate ? dateString : "-"}</div>
            </div> 
        )
    }

    const getVPHistoryBody = (row) => {
        const relatedVendorPayments = vendorPayments.filter(eachVendorPayment => eachVendorPayment.sellerPOId === row.sellerPOId)

        const handleViewVendorPayments = () => {
            setIsVendorPaymentHistoryVisible(true) 
            setDisplayedVendorPayments(relatedVendorPayments)
        }

        return(
            <div className="flex flex-column">
                <div className="flex align-items-center justify-content-center">
                    <a style={{ cursor: "pointer", textDecoration: row?.sellerPOStatus === 6 ? 'line-through' : 'underline' }} onClick={() => handleViewVendorPayments()} > View </a>
                    <a style={{ cursor: "pointer" }} onClick={() => window.open(`/vendor_payment_summary/${row.sellerPOId}`, '_blank')} >
                        <img className="ml-1" src={VPRupeeImg} style={{ height: 15 }} />
                    </a>
                </div>
                {
                    row.tdsAmount ? 
                    <span style={{fontSize: "12px", textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none'}}>TDS</span>
                    :
                    <span style={{fontSize: "12px", textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none'}}>NO TDS</span>
                }
            </div>
        )
    }

    const getStatusBody = (row) => {
        if (row?.sellerPOStatus === 6) {
            return (
                <div style={{ textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none' }}>
                    Seller PO Cancelled
                </div>
            );
        } else if (row?.buyerPOStatus === 4 || row?.buyerPOStatus === 6) {
            return (
                <div>
                    Buyer PO FC/ Cancelled
                </div>
            );
        }
    }

    const handleRaiseTicket = (row) => {
        setSelectedRow(row)
        setIsRaiseTicketVisible(true)
    }

    const raiseIssueBody = (row) => {
        let isPermitted = false
        // checkPermissions({ ...usersData, permissions: [170] })
        if(sellerPIProcessLine && sellerPIProcessLine.lineOwnersList?.includes(usersData.userId)){
            isPermitted = true
        }

        let relatedTicket = null 
        if(row.tickets && row.tickets.length > 0){
            relatedTicket = row.tickets[0]
        }

        let lineOwnersNames = []
        if(!isPermitted && sellerPIProcessLine.lineOwnersList){
            lineOwnersNames = sellerPIProcessLine.lineOwnersList.map(eachListOwner => {
                const relatedUserDetails = usersList.find(eachUser => eachUser.userId === eachListOwner)
                if(relatedUserDetails){
                    return getFullName(relatedUserDetails.firstName, relatedUserDetails.lastName)
                }
                return ``
            })
        }

        return (
            <div>
                {relatedTicket ? (
                    ([1,9,10].includes(relatedTicket["ticketStatusId"])) ? (
                        <a style={{ cursor: "pointer", fontSize: "20px", color: "grey" }} onClick={() => window.open(`/tickets/edit/${relatedTicket.ticketId}`, '_blank')} title={'In Progress'}>
                            <img src={WorkInProgressImg} style={{height: 23}}/>
                        </a>
                    ) :
                    relatedTicket["ticketStatusId"] === 8 ? (
                        <a
                          style={{ cursor: "pointer", fontSize: "20px", color: "orange" }}
                          onClick={() => window.open(`/tickets/edit/${relatedTicket.ticketId}`, '_blank')}
                          title={'Pending Closure'}
                        > <img src={greyClockImg} style={{height: 24}}/></a>
                      ) : (
                        <a style={{ cursor: "pointer", fontSize: "20px", color: "darkgreen" }} onClick={() => window.open(`/tickets/edit/${relatedTicket.ticketId}`, '_blank')} title={'Resolved'}>
                            <img src={checkInCircleImg} style={{height: 30}} />
                        </a>
                    )
                ) : (
                    <>
                        <i style={{ cursor: isPermitted? "pointer" : "not-allowed", fontSize: "20px", color: "red" }}
                            className={`${isPermitted ? 'cursor-pointer' : 'disabled-icon' } custom-raise-tooltip`}
                            onClick={isPermitted ? () => handleRaiseTicket(row) : null}
                        >
                            <img src={RaiseImg} style={{height: 26}}/>
                        </i>
                        {
                            !isPermitted && (
                                <Tooltip target={`.custom-raise-tooltip`} position="top" autoHide>
                                    {`Access restricted to ${lineOwnersNames.join(", ")}`}
                                </Tooltip>
                            )
                        }
                    </>
                )}
            </div>
        )
    }

    const getTDSStatusBody = (row) => {
        if(row.tdsAmount){
            return <span style={{fontSize: "12px", textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none'}}>INCLUDED</span>
        } else {
            return <span style={{fontSize: "12px", textDecoration: row?.sellerPOStatus ===6 ? 'line-through' : 'none'}}>NOT INCLUDED</span>
        }
    }    

    const getSellerPODocNo = (row)=>{
        const date = moment(row?.sellerPOCreatedDate).format(DATE_TIME_FORMAT)

        return(
            <div className='req-no-container' style={{position: "relative"}}>
            {
                row.expenseCategoryId ? <><span style={{fontSize: "12px", fontWeight: "bold"}}>EXPENSE</span><br /></> : null
            }
            <div className='flex flex-row justify-content-center align-items-center'>
                {
                    row?.sellerPODocNo ? 
                    <>
                        <CopyToClipboard text={row.sellerPODocNo} />
                        <p className='doc-no' style={{cursor: "pointer", textDecoration: row.sellerPOStatus ===6 ? 'line-through' : 'none'}} onClick={() => window.open(`/sellerpo/${row?.sellerPOId}`, "_blank")} >{row?.sellerPODocNo}</p>
                        {row.mongoSellerPOId ? <i className="pi pi-external-link pl-1 doc-copy-icon" onClick={() => window.open(`https://app.procmart.com/admin/sellerpo/${row.mongoSellerPOId}`, "_blank")} ></i> : null}
                        <i className="pi pi-copy pl-1 doc-copy-icon" onClick={() => handleCopyClick(row?.sellerPODocNo)} ></i> 
                    </>
                    : ""
                } 
            </div>
            {/* <p className='mr-4 date'>{row["sellerPO.companies.companyName"]}</p> */}
            <p className='date'>{date}</p>
        </div>
        )
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }

    const tableColumns = [
        {
            header: getHeaderCheckbox, body: (row) => getBodyCheckbox(row)
        },
        {
            header: 'Company Name',
            field: '',
            style: {minWidth: "150px"},
            body : getCompanyBody
        },
        {
            header: 'Seller PO No',
            field: '',
            body: getSellerPODocNo,
            style: { minWidth:"100px"}
        },
        {
            header : 'KAM Name' ,
            field : '',
            body : getKAMBody,
            style: { minWidth:"180px"}
        },
        // {
        //     header: 'VP Status',
        //     field: '',
        // },
        {
            header: 'Purchase Invoice',
            field: '',
            body : getPurchaseInvoiceBody,
            style: { minWidth:"140px"}
        },
        {
            header: 'PI Date',
            field: '',
            body : getSellerPIDateBody,
            style: { minWidth:"90px"}
        },
        // {
        //     header: 'PI Uploaded Date',
        //     field: '',
        //     body : getSellerPIUploadedDateBody,
        //     style: {minWidth: "130px"},
        // },
        ...(isSellerEInvoiceApplicable ? [{
            header: 'E-Invoice',
            field: '',
            body : getEInvoiceBody,
            style: { minWidth:"170px"},
        }] : []),
        {
            header: 'Total Amount',
            field: '',
            body: getTotalAmountBody,
            style: { minWidth:"90px"}
        }, 
        {
            header: 'VP History',
            field: '',
            body: getVPHistoryBody,
            style: { minWidth:"70px"}
        },
        // {
        //     header: 'TDS Status',
        //     field: '',
        //     body: getTDSStatusBody,
        //     style: { minWidth:"130px"}
        // },
        {
            header: 'Is Booked',
            field: '',
            body: getBookingStatusBody,
            style: { minWidth:"100px"}
        },
        {
            header: 'Is Verified',
            field: '',
            style: {minWidth: "100px"},
            body: getVerificationStatus
        },
        {
            header: 'Remark',
            field: '',
            body: getStatusBody
        },
        {
            header: 'Raise Issue',
            field: '',
            body: raiseIssueBody
        },
    ]

    const handleCheckboxClick = (row) => {
        const relatedSellerPIPunch = selectedSellerPIPunch?.find(eachSellerPIPunch => eachSellerPIPunch.sellerPIPunchId === row?.sellerPIPunchId)
        if (relatedSellerPIPunch){
            const relatedSellerPIPunches = selectedSellerPIPunch?.filter(eachSellerPIPunch => eachSellerPIPunch?.sellerPIPunchId !== relatedSellerPIPunch?.sellerPIPunchId)
            setSelectedSellerPIPunch(relatedSellerPIPunches)
        }else {
            const relatedSellerPIPunches = [...selectedSellerPIPunch, row]
            setSelectedSellerPIPunch(relatedSellerPIPunches)
        }
    }

    const handleSelectClick = (e) => {
        const relatedSellerPIPunch = sellerPIPunch?.map(eachSellerPIPunch => eachSellerPIPunch)
        if (e.checked){
            setSelectedSellerPIPunch(relatedSellerPIPunch)
        }else{
            setSelectedSellerPIPunch([])
        }
    }
    
    const handlePageChange = async (e) => {
        
        let paginatorParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }
        
        if (searchParams.searchBy && searchParams.searchBy !== "all") {
            paginatorParams[searchParams.searchBy] = searchParams.searchText.trim();
        }
        dispatch(fetchInvoiceBookingList(paginatorParams))
    }

    const handleDuplicatePIPunches = async (bookingType) => {
        const unVerifiedSellerPIPunch = selectedSellerPIPunch.find(eachSellerPIPunch => !eachSellerPIPunch.verifiedBy)
        if (unVerifiedSellerPIPunch && !autoSkipPIVerification) {
            return dispatch(raiseToast({ severity: 'error', detail: `PI: ${unVerifiedSellerPIPunch.sellerPINumber} - ${unVerifiedSellerPIPunch.PIDocNo} is not verified!`, life: 3000 }))
        }

        if (selectedSellerPIPunch.length > 0) {
            let confirmMsg = bookingType === "BOOK" ? 'Confirm to book' : 'Confirm to unbook'
            if (window.confirm(confirmMsg)) {
                setIsLoading(true)
                const piWiseInvoiceBookingAlertsRes = await getPIInvoiceBookingAlerts({ sellerPIPunches: selectedSellerPIPunch })

                if (piWiseInvoiceBookingAlertsRes.failure) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'error', summary: 'piWiseInvoiceBookingAlertsRes', detail: piWiseInvoiceBookingAlertsRes.data.error, life: 3000 }))
                }

                setDuplicatePIPunches(piWiseInvoiceBookingAlertsRes.data.duplicatePIPunches)
                piWiseInvoiceBookingAlertsRes.data.sellerPOItemsWithVendorPaymentButGRNNotDone.map(eachPOItem => {
                    let leadTime = parseInt(eachPOItem.leadTime)
                    const deliveryDate = addDaysToDate(eachPOItem.createdAt, leadTime)
                    const modifiedDeliveryDate = new Date(deliveryDate)
                    eachPOItem.modifiedDeliveryDate = modifiedDeliveryDate
                }) 
                
                setSellerPOItemsWithVendorPaymentButGRNNotDone(piWiseInvoiceBookingAlertsRes.data.sellerPOItemsWithVendorPaymentButGRNNotDone)
                setIsLoading(false)

                if (piWiseInvoiceBookingAlertsRes.data.duplicatePIPunches.length || piWiseInvoiceBookingAlertsRes.data.sellerPOItemsWithVendorPaymentButGRNNotDone.length) {
                    setVisibleDuplicatePIPunchesView(true)
                    setPresentBookingStatus(bookingType)
                }
                else {
                    if (bookingType === "BOOK") {
                        const isBookedInvoicePresent = selectedSellerPIPunch.find(eachPIPunch => eachPIPunch.bookedStatus)
                        if(isBookedInvoicePresent){
                            return dispatch(raiseToast({severity:'error', detail: 'Please select unbooked invoices only', life: 3000}))
                        }

                        const openTicketExist =  selectedSellerPIPunch.some(eachSellerPIPunch => eachSellerPIPunch.tickets && eachSellerPIPunch.tickets[0].ticketStatusId !== 2 )
                        if(openTicketExist){
                            setIsVisibleConfirmDialog(true)
                        }else{
                            handleBookInVoiceClick(false)
                        }  
                    }
                    else {
                        handleUnBookInVoiceClick()
                    }
                }
            }
        }else{
            dispatch(raiseToast({severity:'error', detail: 'Please Select the Purchase Invoices', life: 3000}))
            setPresentBookingStatus('')
        }
    }

    const handleBookInVoiceClick = async (closeTicket) => {
        setIsLoading(true)
        const relatedDocNos = selectedSellerPIPunch.map(eachSellerPIPunch => parseInt(eachSellerPIPunch?.PIDocNo))
        const bookingLogs = selectedSellerPIPunch.map(eachSellerPIPunch => {
            return {
                docNo: eachSellerPIPunch?.PIDocNo,
                bookedBy: usersData?.userId,
                bookedAt: new Date(),
                relatedTicket: eachSellerPIPunch.tickets?.length ? eachSellerPIPunch.tickets[0] : null
            }
        })
        const data = {
            docNos : relatedDocNos,
            bookingStatus : true,
            updatedBy : usersData.userId,
            bookingLogs : bookingLogs,
            closeTicket : closeTicket
        }
        const response = await updatePurchaseInVoiceBookingStatus(data)
        if (response?.failure) {
            dispatch(raiseToast({ severity: 'error', summary: 'Booking Status is not Updated', detail: response.data.error, life: 3000 }))
        } else {
            dispatch(raiseToast({ severity: 'success', detail: 'Booking Status Updated Successfully', life: 3000 }))
            setSelectedSellerPIPunch([])
            setIsVisibleConfirmDialog(false)
            dispatch(fetchInvoiceBookingList({ ...paginationParams, ...searchParams }))
        }
        setPresentBookingStatus('')
        setIsLoading(false)

    }

    const handleUnBookInVoiceClick = async () => {
        const isUnBookedInvoicePresent = selectedSellerPIPunch.find(eachPIPunch => !eachPIPunch.bookedStatus)
        if(isUnBookedInvoicePresent){
            return dispatch(raiseToast({severity:'error', detail: 'Please select booked invoices only', life: 3000}))
        }

        setIsLoading(true)
        const relatedDocNos = selectedSellerPIPunch.map(eachSellerPIPunch => eachSellerPIPunch?.PIDocNo)
        const bookingLogs = selectedSellerPIPunch.map(eachSellerPIPunch => {
            return {
                docNo : eachSellerPIPunch.PIDocNo,
                unbookedBy : usersData.userId,
                unbookedAt : new Date()
            }
        })
        const data = {
            docNos : relatedDocNos,
            bookingStatus : false,
            updatedBy : usersData?.userId,
            bookingLogs : bookingLogs
        }
        const response = await updatePurchaseInVoiceBookingStatus(data)
        if (response?.failure){
            dispatch(raiseToast({severity:'error', summary: 'Booking Status is not Updated', detail:response.data.error, life: 3000}))
        }else {
            dispatch(raiseToast({severity:'success', detail: 'Booking Status Updated Successfully', life: 3000}))
            setSelectedSellerPIPunch([])
            dispatch(fetchInvoiceBookingList({ ...paginationParams, ...searchParams }))
        }
        setPresentBookingStatus('')
        setIsLoading(false)
    }

    const handleDuplicateContinueClick = () => {
        if(presentBookingStatus === "BOOK"){
            handleBookInVoiceClick()
        }
        else{
            handleUnBookInVoiceClick()
        }

        setPresentBookingStatus('')
    }

    const duplicatePIPunchesFoter = () => {
        return(
            <div className="mt-2">
                <Button label="Cancel" severity="danger" outlined onClick={() => {setVisibleDuplicatePIPunchesView(false); setPresentBookingStatus('');}} />
                <Button label="Continue" outlined onClick={handleDuplicateContinueClick} />
            </div>
        )
    }

    const actionButtons = [
        {
            label: "BOOK",
            command: () => handleDuplicatePIPunches('BOOK')
        },
        {
            label: "UNBOOK",
            command: () => handleDuplicatePIPunches('UNBOOK')
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
    ]

    return(
        <div className="piwise-invoce-booking-layout flex flex-column">
            <Toast ref={Toast} />
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="m-2">INVOICE BOOKING (PI WISE)</h4> 
                <div className="warehouse-display-container">
                    <PIInvoiceBookingDashboard  />
                </div>
                <div className="flex gap-2 justify-content-end mb-2 ml-1 warehouse-button-container">
                    {/* <div className='req-action-Body'>
                        <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 mr-2 green-text" label="BOOK" onClick={() => handleDuplicatePIPunches('BOOK')} />
                        <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 red-text" label="UNBOOK" onClick={() => handleDuplicatePIPunches('UNBOOK')} />
                    </div>
                    <div className="flex justify-content-end mb-2">
                        <Button icon="pi pi-filter" className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} />
                    </div> */}
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <div className='flex flex-row'>
                <div className="pi-wise-invoice-booking-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%"}}>
                    <div className='p-card mb-0'>
                        <div className="flex-grow-1">
                            <Table
                                lazy
                                page={paginationParams.pageNo}
                                onPageChange={(e) => handlePageChange(e)}
                                tableColumns={tableColumns}
                                data={sellerPIPunch}
                                rows={paginationParams.recordsPerPage}
                                scrollable={"true"}
                                scrollHeight="480px"
                                paginator
                                totalRecords={paginationParams.totalRecords}
                                loading={isTableLoading}
                            />
                        </div>
                    </div>
                </div>
                {
                    isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <PIWiseInvoiceSearch expenseCategories={expenseCategories} />
                    </div>
                }

                {
                    isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <PIWiseInvoiceSearch expenseCategories={expenseCategories} />
                        </Sidebar>  
                    </div>
                }
            </div>

            <Loading visible={isLoading} />

            <Dialog className="seller-po-and-pi-dialog" header="Seller PO and PI"  visible={visiblePIAndSellerPOSplitView} style={{ width: '90vw', height: '85vh'}} onHide={() => setVisiblePIAndSellerPOSplitView(false)}>
                <SellerPOAndPISplitView sellerPOURL={selectedInvoice?.sellerPODocumentURL} sellerPIDoc={selectedInvoice?.sellerPIDocProof} />
            </Dialog>

            <Dialog header="Alerts"  visible={visibleDuplicatePIPunchesView} style={{ width: '50vw', height: '85vh'}} onHide={() => {setVisibleDuplicatePIPunchesView(false); setPresentBookingStatus('');}} footer={duplicatePIPunchesFoter}>
                <PIWiseInvoiceBookingAlertsDialog duplicatePIPunches={duplicatePIPunches} sellerPOItemsWithVendorPaymentButGRNNotDone={sellerPOItemsWithVendorPaymentButGRNNotDone} pmCompanyUsers={usersList} />
            </Dialog>

            <Dialog header="VENDOR PAYMENT HISTORY" visible={isVendorPaymentHistoryVisible} style={{ width: '75vw', minHeight: '30vh' }} onHide={() => {setIsVendorPaymentHistoryVisible(false); setDisplayedVendorPayments([])}}>
                <div className="vendor-payment-summary-tab" style={{width: "100%", paddingLeft: "0%", paddingRight: "0%"}}>
                    <PaymentHistory vendorPayments={displayedVendorPayments} sellerPIPunch={sellerPIPunch} statusList={statusList} viewFlag={true} />
                </div>
            </Dialog>
            <Dialog header="RAISE TICKET" visible={isRaiseTicketVisible} style={{ width: '40vw', minHeight: '30vh' }} onHide={() => {setIsRaiseTicketVisible(false)}}>
                <div style={{width: "100%", paddingLeft: "0%", paddingRight: "0%"}}>
                    <RaiseTicketModal selectedRow={selectedRow} setIsLoading={setIsLoading} setIsRaiseTicketVisible={setIsRaiseTicketVisible} sellerPIPunch={sellerPIPunch} />
                </div>
            </Dialog>
            <Dialog header="" visible={isVisibleConfirmDialog} style={{ width: '20%', height: '200px', backgroundColor: '#f8f8f8', position: "" }} onHide={() => setIsVisibleConfirmDialog(false)}>
                <p>Do you also want to close the open tickets?</p>
                <div className="flex flex-row justify-content-center mt-4">
                    <Button label="No" style={{ backgroundColor: "#00baaa" }} onClick={() => handleBookInVoiceClick(false)} />
                    <Button className="ml-2" label="Yes" style={{ backgroundColor: "#00baaa" }}onClick={() => handleBookInVoiceClick(true)} />
                </div>
            </Dialog>
        </div>
    )
}

export default PIWiseInvoiceBooking;